import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(data){
    return Request("get","api/stock-order-analyze",data)
}

async function fetchOne(data){
    return Request("get","api/stock-order-analyze/details",data)
}

async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-order-analyze/export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
  
async function batchExports(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/stock-order-analyze/group-type-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function detailExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-order-analyze/detail-export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
  
async function getLastDate(){
  return Request("get","api/stock-order-analyze/get-last-date")
}
  
export default {
    fetch,
    fetchOne,
    exports,
  detailExport,
  batchExports,
  getLastDate,
}